import { KeyValue } from '@/main/models/common';
import { Result } from '@/main/models/common/resultResponse';
import {
  ProcurementReportScheduleSaveRequest,
  ProcurementReportScheduleSearchGridRequest
} from '@/main/models/request';
import { AxiosResponse } from 'axios';
import { api } from '../base';
import { PaginationResponse } from '@/main/models/common/paginationResponse';
import {
  ProcurementReportScheduleGridResponse,
  ProcurementReportScheduleResponse
} from '@/main/models/response';
import { IProcurementReportScheduleAPI } from '../base/report/procurementReportScheduleApi';

const baseRoute: string = 'ProcurementReportSchedule';

export class ProcurementReportScheduleAPI extends IProcurementReportScheduleAPI {
  getProcurementReportSchedule(
    request: string
  ): Promise<AxiosResponse<Result<ProcurementReportScheduleResponse>>> {
    return api.get(`${baseRoute}/getprocurementreportschedule`, {
      params: { guidProcurementReportSchedule: request }
    });
  }
  removeProcurementReportSchedule(
    request: string
  ): Promise<AxiosResponse<Result<boolean>>> {
    return api.post(
      `${baseRoute}/removeprocurementreportschedule`,
      {},
      { params: { guidProcurementReportSchedule: request } }
    );
  }
  saveProcurementReportSchedule(
    request: ProcurementReportScheduleSaveRequest
  ): Promise<AxiosResponse<Result<ProcurementReportScheduleResponse>>> {
    return api.post(`${baseRoute}/saveprocurementreportschedule`, request);
  }

  procurementReportScheduleSearchGrid(
    request: ProcurementReportScheduleSearchGridRequest
  ): Promise<
    AxiosResponse<PaginationResponse<ProcurementReportScheduleGridResponse[]>>
  > {
    return api.post(
      `${baseRoute}/procurementreportschedulesearchgrid`,
      request
    );
  }
}

